import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

export const profileRoutes: Routes = [
  {
    path: 'profile',
    loadComponent: () =>
      import('@pages/common/common-profile/common-profile').then(
        (m) => m.CommonProfile
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },

  {
    path: 'profile/change-password',
    // canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/common/common-profile/change-password/change-password'
      ).then((m) => m.ChangePassword),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
];
